// export const API_URL = "https://naijainsurancebackend.paperbirdtech.com"
// export const API_URL = "http://localhost:3000"
export const API_URL = "https://naijamedicalbackend.paperbirdtech.com";
export const googleMapAPI = "AIzaSyAR7GNVB9msczUOynRfnMoYE9aVHKzgVHc";
export const WEBSITE_URL = "https://naijamedical.com.ng";
export const RECAPTCHA_SITE_KEY = "6LcxbcopAAAAAPnwIsBW7pr3sxKAsTP1jwDOG2uD";
export const STRIPE_KEY =
  "sk_test_51OcN1bSBagUy9FTJ8VjAdf8nXiqaLY89ZQV4Up8CNvujHMrLFfV7kcDpPMakEHit9qyGwAmyO7SfsAvy98yjKN0W00Pbcv539f";
